window.addEventListener('DOMContentLoaded', function() {
    const facetPanels = document.querySelectorAll('.facets__panel');

    facetPanels.forEach(function(panel) {
        if (panel.id === "Facet-Details-template--30838861431114__main-filter-p-product_type") {
            // questo rimane aperto
            return;
        }

        if (panel.open) {
            panel.open = false;
        }
    });
});